import { WebLayout } from "@/components/shared/layout/homepage";
import { SideNavbar } from "@/components/shared/side-navbar/index.web";
import { View } from "@/components/ui";
import { Container } from "@/components/ui/layout";
import { Outlet } from "react-router-dom";
import { PackageIssueContainer } from "@/containers/profile/packages/report-package-issue/package-issue";
import { VisitDetailContainer } from "@/containers/visits/visit-detail";
import { VisitIssueContainer } from "@/containers/report-issues/visit-issue";
import { useAuthState } from "@/store/auth";
import { useClientPaymentMethodStore } from "@/store/auth/clientPaymentMethod";
import { useEffect } from "react";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";

export function ProfilePage() {
  const { isMobile } = useWindowDimensions();
  const clientId = useAuthState((state) => state.data.userInfo.id);
  const getClientPaymentMethod = useClientPaymentMethodStore(
    (state) => state.fetch,
  );
  useEffect(() => {
    if (clientId) {
      getClientPaymentMethod({ requestPayload: { id: clientId } });
    }
  }, [clientId]);
  return (
    <WebLayout>
      <Container gap="xl">
        {!isMobile ? (
          <View className="w-full max-w-[224px] md:mt-10">
            <SideNavbar />
          </View>
        ) : null}
        <View className="flex-1 pb-10 md:mt-10">
          <Outlet />
        </View>
      </Container>
      <PackageIssueContainer />
      <VisitDetailContainer />
      <VisitIssueContainer />
    </WebLayout>
  );
}
